module.exports = __webpack_public_path__ + "static/project-3a-705a70e47d3b3f8745b3f099198d8850.png";